import { Header, Trigger } from "@radix-ui/react-accordion";
import type React from "react";

import { cn } from "@/lib/utils";

import { ChevronDown } from "lucide-react";

interface AccordionHeaderProps {
  className?: string;
  children: string | React.JSX.Element | React.JSX.Element[];
  onClick: () => void;
  chevronClassName?: string;
  rightChevron?: boolean;
  compact?: boolean;
}

const AccordionHeader = ({
  className = "",
  children,
  onClick,
  chevronClassName = "",
  rightChevron = false,
  compact = false,
  ...props
}: AccordionHeaderProps) => (
  <Header className="flex m-0">
    <Trigger
      onClick={onClick}
      className={cn(
        "flex flex-1 border-0 cursor-pointer w-full items-center gap-2 px-2 text-left transition-all",
        compact ? "py-1" : "py-4",
        rightChevron
          ? "[&[data-state=open]>svg]:rotate-0"
          : "[&[data-state=open]>svg]:rotate-180",
        className,
      )}
      {...props}
    >
      <ChevronDown
        className={cn(
          "h-4 w-4 shrink-0 transition-transform duration-200",
          rightChevron && "-rotate-90",
          chevronClassName,
        )}
      />
      {children}
    </Trigger>
  </Header>
);

export { AccordionHeader };
